module.exports = __webpack_public_path__ + "img/longhornsiconPNG.9677147c.png";